import { useFormContext } from 'react-hook-form'
import { ServiceCatalog } from '../ServiceCatalog'
import { SubtotalPanel } from '../SubtotalPanel'
import { usePackageCatalog } from '../../hooks/usePackageCatalog'

/**
 * Forma mínima del form que necesita el paso. Es agnóstico al schema concreto
 * (sirve tanto para el wizard de organización como el de negocio adicional):
 * ambos exponen `packageServiceIds` y `licenseType`.
 */
interface ServicesStepFormShape {
  packageServiceIds?: number[]
  licenseType?: 'MONTHLY' | 'ANNUAL'
}

/**
 * Paso 2 de los wizards: selección de servicios con panel de subtotal en vivo.
 * Lee/escribe `packageServiceIds` directamente del form context.
 */
export function ServicesStep() {
  const { watch, setValue } = useFormContext<ServicesStepFormShape>()
  const { byId } = usePackageCatalog()

  const selectedIds = watch('packageServiceIds') ?? []
  const billingType = watch('licenseType') ?? 'MONTHLY'

  const toggle = (id: number) => {
    const next = selectedIds.includes(id)
      ? selectedIds.filter((x) => x !== id)
      : [...selectedIds, id]
    setValue('packageServiceIds', next, { shouldValidate: true, shouldDirty: true })
  }

  return (
    <div className="grid gap-6 lg:grid-cols-[1fr_300px]">
      <div>
        <p className="mb-4 text-sm text-ink-muted">
          Elige los servicios que quieres contratar para este negocio. Podrás ajustarlos
          más adelante desde el detalle del negocio.
        </p>
        <ServiceCatalog mode="select" selectedIds={selectedIds} onToggle={toggle} />
      </div>
      <SubtotalPanel selectedIds={selectedIds} byId={byId} billingType={billingType} />
    </div>
  )
}
